/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import useImpactPriorities from './helper';
import DafTable from '../../../../components/Table/newTable';

export default function MinePipeline({ amps = [] }) {
  const { t } = useTranslation();
  const { columns } = useImpactPriorities();
  const data = useMemo(() => amps.map((amp, i) => ({
    ...amp,
    key: `${amp.id}-${i}`,
  })), []);

  return (
    <Widget
      className="with-border-header no-px-body overflow-hidden"
      title={t('Mine Pipeline')}
    >
      <Style>
        <div className='daf-table-wrapper pagination-w-padding no-pagination'>
          <DafTable
            pagination={{ pageSize: 8 }}
            data={data}
            doEmptyRows
            columns={columns}
            size="small"
            scroll={{ y: 340 }}
          />
        </div>
      </Style>
    </Widget>
  )
}
